import GuidelineTables from "../../../components/TablesAndFigures/GuidelineTables/GuidelineTables";
import GuidelineFigures from "../../../components/TablesAndFigures/GuidelineFigures/GuidelineFigures";

export const tablesAndFiguresTabs = [
  {
    id: "tables",
    label: "Tables",
    component: GuidelineTables,
  },
  {
    id: "figures",
    label: "Figures",
    component: GuidelineFigures,
  },
];